/* TextColorIcon.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./TextColorIcon.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import Icon from '@atlaskit/icon/core/text-style';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  icon: "_19pk12x7"
};
export var TextColorIcon = function TextColorIcon(_ref) {
  var label = _ref.label,
    shouldRecommendSmallIcon = _ref.shouldRecommendSmallIcon,
    size = _ref.size,
    spacing = _ref.spacing,
    testId = _ref.testId,
    iconColor = _ref.iconColor,
    isDisabled = _ref.isDisabled;
  return /*#__PURE__*/React.createElement(Box, {
    as: "span",
    xcss: styles.icon
  }, /*#__PURE__*/React.createElement(Icon, {
    label: label,
    testId: testId,
    color: isDisabled ? "var(--ds-icon-disabled, #091E424F)" : iconColor,
    shouldRecommendSmallIcon: shouldRecommendSmallIcon,
    spacing: spacing,
    size: size
  }));
};